import logo_vk from '../files/system/VK_Logo_White.svg';
import logo_ya from '../files/system/Ya_Logo.svg';
import "./ButtonSocial.css"

function ButtonSocial({ text, onClick, loading, type }) {


    return (
        <>
            {type === 'vk' && (
                <button className={loading === true ? "button_social loading" : "button_social"} onClick={() => onClick()} disabled={loading}>
                    <img className="img" src={logo_vk}></img>
                    <div className='text'> Войти с VK ID</div>
                </button>
            )}
            {type === 'ya' && (
                <button className={loading === true ? "button_social loading" : "button_social"} onClick={() => onClick()} disabled={loading}>
                    <img className="img" src={logo_ya}></img>
                    <div className='text'> Войти с Yandex ID</div>
                </button>
            )}
        </>
    );
}

export default ButtonSocial;